const NEW_API_CONSENT_KEY = "reqxign-new-api-consent";

export const useNewApiConsent = () => {
  const hasConsented = (): boolean => {
    return localStorage.getItem(NEW_API_CONSENT_KEY) !== null;
  };

  const markAsConsented = (): void => {
    localStorage.setItem(NEW_API_CONSENT_KEY, Date.now().toString());
  };

  return { hasConsented, markAsConsented };
};
